<template>
    <div>
        <v-dialog max-width="600" persistent v-model="$store.getters.libraryInfoModal">
            <v-snackbar
                    v-model="snackbar" bottom
                    color="cyan darken-3"
                    timeout="1000">
                Αντιγράφηκε στο πρόχειρο
                <v-icon color="white">mdi-check-all</v-icon>
            </v-snackbar>
            <v-card id="flashCard">

                <v-card-title class="primary">
                    <span class="headline white--text text-center">Στοιχεία Επικοινωνίας</span>
                    <v-icon @click="copyAll" color="white">mdi-content-copy</v-icon>
                    <v-spacer></v-spacer>
                    <v-icon @click="exitInfoModal" color="white">close</v-icon>
                </v-card-title>
                <v-card-text>
                        <v-container class="pt-0 mt-0 pb-0">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Ίδρυμα
                                        <v-icon @click="copyToClipboard('Ίδρυμα: ' + libraryInfoObject.institution)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.institution}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Βιβλιοθήκη
                                        <v-icon @click="copyToClipboard('Βιβλιοθήκη: ' + libraryInfoObject.name)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.name}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Διεύθυνση
                                        <v-icon @click="copyToClipboard('Διεύθυνση: ' + libraryInfoObject.address)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.address}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Τ.Κ
                                        <v-icon @click="copyToClipboard('Τ.Κ: ' + libraryInfoObject.zipCode)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.zipCode}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Τηλέφωνο (Σταθερό)
                                        <v-icon @click="copyToClipboard('Τηλέφωνο (Σταθερό): ' + libraryInfoObject.phone)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.phone}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        E-Mail
                                        <v-icon @click="copyToClipboard('E-Mail: ' + libraryInfoObject.libraryEmail)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.libraryEmail}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Πόλη
                                        <v-icon @click="copyToClipboard('Πόλη: ' + libraryInfoObject.city)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.city}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Νομός
                                        <v-icon @click="copyToClipboard('Νομός: ' + libraryInfoObject.prefecture)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.prefecture}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Χάρτης
                                        <v-icon @click="copyToClipboard('Χάρτης: ', )" small color="black">+di.locationURL)-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle v-if="libraryInfoObject.locationURL != null" @click="goToMap(libraryInfoObject.locationURL)">
                                        <a>Πατήστε Εδώ</a>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Υπεύθυνος για το Εύδοξος
                                        <v-icon @click="copyToClipboard('Υπεύθυνος για το Εύδοξος: ' + libraryInfoObject.contactName)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.contactName}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Τηλέφωνο Υπεύθυνου επικοινωνίας για το Εύδοξος
                                        <v-icon @click="copyToClipboard('Τηλέφωνο Υπεύθυνου επικοινωνίας για το Εύδοξος: ' + libraryInfoObject.contactPhone)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.contactPhone}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Κινητό Υπεύθυνου επικοινωνίας για το Εύδοξος
                                        <v-icon @click="copyToClipboard('Κινητό Υπεύθυνου επικοινωνίας για το Εύδοξος: ' + libraryInfoObject.contactMobilePhone)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.contactMobilePhone}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        E-Mail Υπεύθυνου επικοινωνίας για το Εύδοξος
                                        <v-icon @click="copyToClipboard('E-Mail Υπεύθυνου επικοινωνίας για το Εύδοξος: ' + libraryInfoObject.contactEmail)" small color="black">mdi-content-copy</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{libraryInfoObject.contactEmail}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                        </v-container>
                    </v-card-text>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import BrailleIcon from "vue-material-design-icons/Braille";

    export default {
        name: "LibraryInfoModal",
        components: {BrailleIcon},
        data: () => ({
	        snackbar:false,
        }),
        props: {
            libraryInfoObject: Object
        },

        methods: {

	        copyAll(){
		        document.activeElement.blur();
		        let text = 'Ίδρυμα: ' + this.libraryInfoObject.institution +'\n'+
                'Βιβλιοθήκη: ' + this.libraryInfoObject.name +'\n'+
                'Διεύθυνση: ' + this.libraryInfoObject.address +'\n'+
                'Τ.Κ: ' + this.libraryInfoObject.zipCode +'\n'+
                'Τηλέφωνο (Σταθερό): ' + this.libraryInfoObject.phone +'\n'+
                'E-Mail: ' + this.libraryInfoObject.libraryEmail +'\n'+
                'Πόλη: ' + this.libraryInfoObject.city +'\n'+
                'Νομός: ' + this.libraryInfoObject.prefecture +'\n'+
                'Υπεύθυνος για το Εύδοξος: ' + this.libraryInfoObject.contactName +'\n'+
                'Τηλέφωνο Υπεύθυνου επικοινωνίας για το Εύδοξος: ' + this.libraryInfoObject.contactPhone +'\n'+
                'Κινητό Υπεύθυνου επικοινωνίας για το Εύδοξος: ' + this.libraryInfoObject.contactMobilePhone +'\n'+
                'E-Mail Υπεύθυνου επικοινωνίας για το Εύδοξος: ' + this.libraryInfoObject.contactEmail +'\n';
		        navigator.clipboard.writeText(text);
		        this.snackbar = true;

            },

	        copyToClipboard(value){
		        document.activeElement.blur();
		        navigator.clipboard.writeText(value);
		        this.snackbar = true;
            },

            // exit from modal
            exitInfoModal() {

                this.$store.commit('setLibraryInfoModal', false);
            },

            //open map in new tab
            goToMap(url) {

                window.open(url, '_blank');
            },

        }
    }
</script>

<style scoped>

</style>